export const debug = process.env.NODE_ENV === "production" && process.env.DEBUG !== "1" ? () => { } : console.log;
